import React from 'react'

const OptimizedImage = ({
    src,
    alt,
    className,
    sizes,
    srcSet,
    width,
    height,
    decoding = 'async',
    fetchpriority = 'auto',
    loading = 'lazy',
    style,
    // Optional modern formats
    webpSrcSet,
    avifSrcSet
}) => {
    // If responsive modern sources provided, render a <picture>
    if (webpSrcSet || avifSrcSet) {
        return (
            <picture style={style}>
                {avifSrcSet ? <source type="image/avif" srcSet={avifSrcSet} sizes={sizes} /> : null}
                {webpSrcSet ? <source type="image/webp" srcSet={webpSrcSet} sizes={sizes} /> : null}
                <img 
                    src={src} 
                    alt={alt} 
                    className={className} 
                    loading={loading} 
                    decoding={decoding} 
                    fetchpriority={fetchpriority} 
                    sizes={sizes} 
                    srcSet={srcSet} 
                    width={width} 
                    height={height} 
                    style={style}
                    // Add performance optimizations
                    crossOrigin="anonymous"
                />
            </picture>
        )
    }

    return (
        <img 
            src={src} 
            alt={alt} 
            className={className} 
            loading={loading} 
            decoding={decoding} 
            fetchpriority={fetchpriority} 
            sizes={sizes} 
            srcSet={srcSet} 
            width={width} 
            height={height} 
            style={style}
            // Add performance optimizations
            crossOrigin="anonymous"
        />
    )
}

export default OptimizedImage